import { useEffect, useState } from 'react'
import { getVerifTinHistory } from 'services'
import { Modal, PlainTable } from 'stories/components'
import { formatTime } from 'utils'

export const TinVerifyModal = ({ loanNumber, onClose }: { loanNumber: number; onClose: Function }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<any>>([])

  useEffect(() => {
    setLoading(true)
    getVerifTinHistory()
      .then((res) => {
        let rlt: any = []
        res.map((log: any, index: number) => {
          rlt.push([
            index + 1,
            formatTime(log.createdAt),
            log.operator,
            log.name,
            log.tin,
            <div className={`p-2 rounded-md min-w-[80px] text-center ${log.value ? 'bg-green-300' : 'bg-red-300'}`}>
              {log.value ? 'Success' : 'Failed'}
            </div>,
          ])
        })
        setData(rlt)
      })
      .finally(() => setLoading(false))
  }, [loanNumber])

  return (
    <Modal
      button={<span></span>}
      title={'Entity Tax ID Verification History'}
      titleOkay=""
      isOpen={true}
      onClose={() => onClose()}
      childLevel={1}
      loading={loading}
    >
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg max-w-screen-xl">
        <PlainTable header={['No', 'Date & Time', 'Email', 'Entity Name', 'Entity Tax ID', 'Status']} data={data} />
      </div>
    </Modal>
  )
}
